import {
  DependencyList,
  EffectCallback,
  useEffect,
  useMemo,
  useRef,
} from 'react';

// https://github.com/mui-org/material-ui/blob/master/packages/material-ui-styles/src/makeStyles/makeStyles.js#L162
export function useSyncEffect(
  callback: EffectCallback,
  deps: DependencyList,
): void {
  const key = useRef({});
  let cleanup: ReturnType<EffectCallback>;

  // Store "generation" key. Just returns a new object every time
  const currentKey = useMemo(() => ({}), deps); // eslint-disable-line react-hooks/exhaustive-deps

  // "the first render", or "memo dropped the value"
  if (key.current !== currentKey) {
    key.current = currentKey;
    cleanup = callback();
  }

  useEffect(
    () => () => {
      if (cleanup) {
        cleanup();
      }
    },
    [currentKey], // eslint-disable-line react-hooks/exhaustive-deps
  );
}
